import Vue from 'vue'

var numeral = require('numeral')
Vue.filter('currency', function (value) {
  return numeral(value).format('0,0.00') // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('percentage', function (value) {
  return numeral(value).format('0,0.00') + '%' // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('integer', function (value) {
  return numeral(value).format('0,0') // displaying other groupings/separators is possible, look at the docs
})
Vue.filter('size', function (value) {
  var divisor = 1
  var suffix = ''
  if (value > 1099511627776) {
    divisor = 1099511627776
    suffix = 'tb'
  } else if (value > 1073741824) {
    divisor = 1073741824
    suffix = 'gb'
  } else if (value > 1048576) {
    divisor = 1048576
    suffix = ' mb'
  } else if (value > 1024) {
    divisor = 1024
    suffix = ' kb'
  }
  return (value / divisor).toFixed(2) + suffix
})

Vue.filter('since', function (dateString) {
  var dateValue = Date.parse(dateString)
  var now = new Date()
  var difference = now.getTime() - dateValue
  var divisor = 1
  var suffix = ''
  if (difference > 31536000000) {
    divisor = 31536000000
    suffix = 'year'
  } else if (difference > 31536000000) {
    divisor = 31536000000
    suffix = 'month'
  } else if (difference > 31536000000) {
    divisor = 31536000000
    suffix = ' week'
  } else if (difference > 86400000) {
    divisor = 86400000
    suffix = ' day'
  } else if (difference > 3600000) {
    divisor = 3600000
    suffix = ' hour'
  } else if (difference > 60000) {
    divisor = 60000
    suffix = ' minute'
  } else if (difference > 1000) {
    divisor = 1000
    suffix = ' second'
  }
  var displayValue = (difference / divisor).toFixed(0)
  if (displayValue > 1) {
    suffix = suffix + 's'
  }
  return displayValue + suffix + ' ago'
})

Vue.filter('ellipsis', function (value, limit) {
  if (value.length > limit) {
    return value.substring(0, limit - 3) + '...'
  } else {
    return value
  }
})

Vue.prototype.$filters = Vue.options.filters



// WEBPACK FOOTER //
// ./src/filters.js